import { CommonModule, TitleCasePipe } from "@angular/common";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgbCollapseModule, NgbTypeaheadModule, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
// import { ColorPickerModule } from "ngx-color-picker";
import { PerfectScrollbarConfigInterface, PERFECT_SCROLLBAR_CONFIG } from "ngx-perfect-scrollbar";
import { GeoCoordinateValidator } from "src/app/actions/admin/validators/geo-coordinate-validator";
import { TranslationService } from "src/app/services";
import { NavigationService, BaseComponentContext } from "../tcm-core.module";
import { TCMCoreModule } from "../tcm-core.module/tcm-core.module";
import { TCMFormModule } from "../tcm-form/tcm-form.module";
import { AllOptionWrapperComponent } from "./components/all-option-wrapper/all-option-wrapper.component";
import { CollapsiblePanelComponent } from "./components/collapsible-panel/collapsible-panel.component";
import { CopyableTextInputComponent } from "./components/copyable-text-input/copyable-text-input.component";
import { EditableTooltipDynamicFormDirective } from "./components/editable-tooltip/editable-tooltip-dynamic-form.directive";
import { EditableTooltipComponent } from "./components/editable-tooltip/editable-tooltip.component";
import { FieldHistoryButtonComponent } from "./components/field-history-button/field-history-button.component";
import { FieldHistorySearchComponent } from "./components/field-history-search/field-history-search.component";
import { FilePreviewComponent } from "./components/file-preview/file-preview.component";
import { ObjectNodeComponent } from "./components/json-editor/object-node/object-node.component";
import { TcmDetailsLayoutComponent } from "./components/layouts/tcm-details-layout/tcm-details-layout.component";
import { TcmLinkedSearchLayoutComponent } from "./components/layouts/tcm-linked-search-layout/tcm-linked-search-layout.component";
import { TcmMainFrameComponent } from "./components/layouts/tcm-main-frame/tcm-main-frame.component";
import { TcmMainSearchLayoutComponent } from "./components/layouts/tcm-main-search-layout/tcm-main-search-layout.component";
import { MapModalComponent } from "./components/map-viewer/map-modal/map-modal.component";
import { MapViewerComponent } from "./components/map-viewer/map-viewer.component";
import { NoteDetailsComponent } from "./components/note-details/note-details.component";
import { PictureLoaderComponent } from "./components/picture-loader/picture-loader.component";
import { RadioButtonsInputComponent } from "./components/radio-buttons-input/radio-buttons-input.component";
import { RouterTabSetComponent } from "./components/router-tabs/router-tab-set.component";
import { RouterTabComponent } from "./components/router-tabs/router-tab.component";
import { SchedulerZoomComponent } from "./components/scheduler-zoom.component/scheduler-zoom.component";
import { SearchResultsComponent } from "./components/search-results/search-results.component";
import { AdvancedSearchComponent } from "./components/searches/advanced-search/advanced-search.component";
import { SearchCommonCommandsComponent } from "./components/searches/search-common-commands/search-common-commands.component";
import { SubGridSignComponent } from "./components/sub-grid-sign/sub-grid-sign.component";
import { TableHeaderComponent } from "./components/table-header/table-header.component";
import { TableMultiSelectRecordComponent } from "./components/table-multi-select-record/table-multi-select-record.component";
import { TableMultiSelectSelectorComponent } from "./components/table-multi-select-selector/table-multi-select-selector.component";
import { TabComponent } from "./components/tabs/tab/tab.component";
import { TabsComponent } from "./components/tabs/tabs/tabs.component";
import { TcmAddressInputComponent } from "./components/tcm-address-autocomplete/tcm-address-autocomplete.component";
import { TcmAddressComponent } from "./components/tcm-address/tcm-address.component";
import { TcmColorPickerInputComponent } from "./components/tcm-color-picker-input/tcm-color-picker-input";
import { TcmFileInputComponent } from "./components/tcm-file-input/tcm-file-input.component";
import { TcmFileUploadComponent } from "./components/tcm-file-upload/tcm-file-upload.component";
import { TcmMessageModalComponent } from "./components/tcm-message-modal/tcm-message-modal.component";
import { TcmPhoneComponent } from "./components/tcm-phone/tcm-phone.component";
import { TcmTaxContentDirective } from "./components/tcm-tax-extension-wrapper/tcm-tax-content/tcm-tax-content.directive";
import { TcmTaxExtensionWrapperComponent } from "./components/tcm-tax-extension-wrapper/tcm-tax-extension-wrapper.component";
import { TcmTooltipComponent } from "./components/tcm-tooltip/tcm-tooltip.component";
import { TcmVideoPlayerComponent } from "./components/tcm-video-player/tcm-video-player.component";
import { ActionButtonDirective } from "./directives/action-button.directive";
import { DynamicFormProviderDirective } from "./directives/dynamic-form-provider/dynamic-form-provider.directive";
import { HasPermissionDirective } from "./directives/has-permission.directive";
import { PermissionCheckDirective } from "./directives/permission-check.directive";
import { StateLabelDirective } from "./directives/state-label/state-label.directive";
import { TcmVarDirective } from "./directives/tcm-var/tcm-var.directive";
import { AtLeastOneValueRequiredValidator } from "./directives/validators/at-least-one-value-required-validator/at-least-one-value-required-validator";
import { ConditionalTimeLessThanValidatorDirective } from "./directives/validators/conditional-time-less-than-validator/conditional-time-less-than-validator.directive";
import { DoesntEqualToValidator } from "./directives/validators/doesnt-equal-to-validator/doesnt-equal-to-validator";
import { EqualToValidator } from "./directives/validators/equal-to-validator/equal-to-validator";
import { GreaterThanOrEqualToValidator } from "./directives/validators/greater-than-or-equal-to-validator/greater-than-or-equal-to-validator";
import { GreaterThanValidator } from "./directives/validators/greater-than-validator/greater-than-validator";
import { GreaterThanZeroValidator } from "./directives/validators/greater-than-zero-validator/greater-than-zero-validator";
import { LessThanOrEqualToValidator } from "./directives/validators/less-than-or-equal-to-validator/less-than-or-equal-to-validator";
import { LessThanValidator } from "./directives/validators/less-than-validator/less-than-validator";
import { MinimumLengthDirective } from "./directives/validators/min-length-validator/minimum-length.directive";
import { NumbersOnlyValidator } from "./directives/validators/numbers-only-validator/numbers-only-validator";
import { ProviderEnrollmentCheckAsyncValidator } from "./directives/validators/provider-enrollment-validator/provider-enrollment-check-async-validator";
import { SingleValueRequiredValidator } from "./directives/validators/single-value-required-validator/single-value-required-validator";
import { TimeLessThanValidatorDirective } from "./directives/validators/time-less-than-validator/time-less-than-validator.directive";
import { UniqueCollectionValidator } from "./directives/validators/unique-collection-validator/unique-collection-validator.directive";
import { UserPasswordValidator } from "./directives/validators/user-password-validator/user-password-validator";
import { WorkingHoursValidator } from "./directives/validators/working-hours-validator/working-hours-validator.directive";
import { SecureBaseComponentContext } from "./services/secure-base-component-context.service";
import { TcmBaseComponentContext } from "./services/tcm-base-component-context.service";
import { TcmModalService } from "./services/tcm-modal.service";
import { TcmModalServiceImplementation } from "./services/tcm-modal.service.impl";
import { SerializedItemProductStyleSerialExistsAsyncValidator } from "./validators/serialized-item-product-style-exists-async-validator";
import { RegexpValidator } from "./directives/validators/regexp-validator/regexp-validator.directive";
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";
import { TcmTabLayoutComponent } from "./components/layouts/tcm-tab-layout/tcm-tab-layout.component";




// const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
//   suppressScrollX: true
// };

const directives = [
  UniqueCollectionValidator,
  LessThanValidator,
  LessThanOrEqualToValidator,
  GreaterThanValidator,
  GreaterThanOrEqualToValidator,
  GreaterThanZeroValidator,
  DoesntEqualToValidator,
  SingleValueRequiredValidator,
  AtLeastOneValueRequiredValidator,
  HasPermissionDirective,
  TcmTaxContentDirective,
  TimeLessThanValidatorDirective,
  ConditionalTimeLessThanValidatorDirective,
  StateLabelDirective,
  ActionButtonDirective,
  TcmVarDirective,
  PermissionCheckDirective,
  UserPasswordValidator,
  DynamicFormProviderDirective,
  WorkingHoursValidator,
  ProviderEnrollmentCheckAsyncValidator,
  GeoCoordinateValidator,
  NumbersOnlyValidator,
  MinimumLengthDirective,
  RegexpValidator
];

const validators = [
  SerializedItemProductStyleSerialExistsAsyncValidator,
  EqualToValidator
];

const components = [
  AllOptionWrapperComponent,
  ObjectNodeComponent,
  RadioButtonsInputComponent,
  TcmColorPickerInputComponent,
  TcmFileInputComponent,
  TcmFileUploadComponent,
  PictureLoaderComponent,
  TabsComponent,
  RouterTabSetComponent,
  RouterTabComponent,
  TcmAddressInputComponent,
  TcmTaxExtensionWrapperComponent,
  TabComponent,
  CollapsiblePanelComponent,
  MapViewerComponent,
  SearchResultsComponent,
  TcmTooltipComponent,
  EditableTooltipComponent,
  TcmMainFrameComponent,
  TcmLinkedSearchLayoutComponent,
  TcmTabLayoutComponent,
  TcmDetailsLayoutComponent,
  AdvancedSearchComponent,
  SearchCommonCommandsComponent,
  TcmMainSearchLayoutComponent,
  SubGridSignComponent,
  TcmAddressComponent,
  FieldHistoryButtonComponent,
  TableMultiSelectSelectorComponent,
  TableMultiSelectRecordComponent,
  TableHeaderComponent,
  CopyableTextInputComponent,
  SchedulerZoomComponent,
  TcmVideoPlayerComponent,
  TcmPhoneComponent
];

@NgModule({
  declarations: [
    components,
    directives,
    validators,
    MapModalComponent,
    TcmMessageModalComponent,
    EditableTooltipDynamicFormDirective,
    FieldHistorySearchComponent,
    FilePreviewComponent,
    NoteDetailsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TCMCoreModule,
    TCMFormModule,
    TranslateModule,
    NgbCollapseModule,
    NgbTypeaheadModule,
    // ColorPickerModule,
    NgbModule,
    // PerfectScrollbarModule // NO COMPATIBLE WITH IVY
    NgxIntlTelInputModule

  ],
  exports: [
    components,
    directives,
    validators
  ],
  providers: [
    TcmBaseComponentContext,
    SecureBaseComponentContext,
    NavigationService,
    { provide: TcmModalService, useClass: TcmModalServiceImplementation },
    // { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
    { provide: BaseComponentContext, useClass: TcmBaseComponentContext },
    TitleCasePipe,
    TranslationService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TcmCommonSharedModule {
}
